import { render, staticRenderFns } from "./foodServiceHome.vue?vue&type=template&id=8bd47eba&scoped=true&"
import script from "./foodServiceHome.vue?vue&type=script&lang=js&"
export * from "./foodServiceHome.vue?vue&type=script&lang=js&"
import style0 from "../../templateAssests/css/home.css?vue&type=style&index=0&id=8bd47eba&scoped=true&lang=css&"
import style1 from "./foodServiceHome.vue?vue&type=style&index=1&id=8bd47eba&scoped=true&lang=css&"
import style2 from "./foodServiceHome.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd47eba",
  null
  
)

export default component.exports